<template>
    <a :class="{ open: active }"
       v-on="$listeners"
       class="mobile-link">
        <span class="link-label">{{ title }}</span>
        <span class="item_switch"></span>
        <div class="loader" v-if="loading"></div>
    </a>
</template>

<script>
    export default {
        name: "CategoryHeader",
        props: {
            title: String,
            active: Boolean,
            loading: Boolean,
        }
    }
</script>

<style scoped lang="scss">

    .loader {
        border: 3px solid #f3f3f3;
        border-top: 3px solid #345463;
        border-radius: 50%;
        width: 15px;
        height: 15px;
        animation: spin 2s linear infinite;
    }

    .mobile-link {
        padding: 20px 0 15px 15px;
        box-sizing: border-box;
        display: -webkit-flex;
        display: flex;
        justify-content: space-between;
        -webkit-justify-content: space-between;
        position: relative;
        flex-wrap: wrap;
        -webkit-flex-wrap: wrap;
        text-decoration: none !important;
        margin: 0;
        width: 100%;
        align-items: center;
        background-color: #ffffff;
        cursor: pointer;

        .item_switch {
            border-left: 6px solid transparent;
            border-right: 6px solid transparent;
            border-top: 6px solid black;
            display: inline-block;
            margin-left: 5px;
            position: absolute;
            right: 10px;
            top: 44%;
        }

        &.open .item_switch {
            border-left: 6px solid transparent;
            border-right: 6px solid transparent;
            border-top: 0 none;
            border-bottom: 6px solid black;
        }

        & .link-label {
            float: left;
            font-size: 14px;
            color: #000000;
            position: relative;
        }
    }

    #for li a.mobile-link,
    #occasions li a.mobile-link {
        font-weight: bold;
    }

</style>
